
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/ir/governance/basics",
      function () {
        return require("private-next-pages/en/ir/governance/basics.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/ir/governance/basics"])
      });
    }
  